import { render, staticRenderFns } from "./UserDesactivated.vue?vue&type=template&id=5778fd98"
import script from "./UserDesactivated.vue?vue&type=script&lang=js"
export * from "./UserDesactivated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports